import { combineReducers } from '@ngrx/store';
import { reducer as acceptedServicesReducer } from './accepted-services/accepted-services.reducer';
import { reducer as declinedServicesReducer } from './declined-services/declined-services.reducer';
import { reducer as maintenanceScheduleReducer } from './maintenance-schedule/maintenance.schedule.reducer';
// eslint-disable-next-line max-len
import { reducer as pendingAcceptedServicesReducer } from './pending-accepted-services/pending-accepted-services.reducer';
// eslint-disable-next-line max-len
import { reducer as pendingDeclinedServicesReducer } from './pending-declined-services/pending-declined-services.reducer';
import { reducer as servicesDueReducer } from './services-due/services-due.reducer';
import { reducer as templateDetailReducer } from './template-detail/template-detail.reducer';
import * as fromVehicleMaintenance from './vehicle-maintenance.actions';
import { OpenedFromTransactionState } from './vehicle-maintenance.interfaces';
import { vehicleMaintenanceInitialState } from './vehicle-maintenance.init';

export function vehicleMaintenanceReducer(
  state: OpenedFromTransactionState,
  action: fromVehicleMaintenance.VehicleMaintenanceAction
): any {
  switch (action.type) {
    case fromVehicleMaintenance.SET_TRANSACTION_FROM_QUERY_PARAMS: {
      return { ...state, ...action.payload };
    }
    case fromVehicleMaintenance.RESET_STATE: {
      return vehicleMaintenanceInitialState;
      break;
    }
    default: {
      return state;
    }
  }
}

const myReducers = {
  maintenanceSchedule: maintenanceScheduleReducer,
  servicesDue: servicesDueReducer,
  templateDetail: templateDetailReducer,
  openedFromTransaction: vehicleMaintenanceReducer,
  acceptedServices: acceptedServicesReducer,
  declinedServices: declinedServicesReducer,
  pendingAcceptedServices: pendingAcceptedServicesReducer,
  pendingDeclinedServices: pendingDeclinedServicesReducer
};

export function createReducer(asyncReducers = {}) {
  let allReducers = Object.assign(myReducers, asyncReducers);
  return combineReducers(allReducers);
}

export function appReducer(state: any, action: any) {
  return createReducer()(state, action);
}

export const reducer = combineReducers(myReducers);
